/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-hall': {
    width: 16,
    height: 16,
    viewBox: '0 0 300 300',
    data: '<path pid="0" d="M258 130v12a6 6 0 01-6 6h-20v-36h10a10 10 0 0010-10V90h-4v12a6 6 0 01-6 6h-10V93.84a14 14 0 10-4 0V128h-10a6 6 0 01-6-6v-12h-4v12a10 10 0 0010 10h10v36h-20a6 6 0 01-6-6v-12h-4v12a10 10 0 0010 10h20v64h-18v8h40v-8h-18v-84h20a10 10 0 0010-10v-12zm-34-50a6 6 0 116 6 6 6 0 01-6-6zM158 56H62a6 6 0 00-6 6v176a6 6 0 006 6h96a6 6 0 006-6V62a6 6 0 00-6-6zm-2 180H64V64h92z"/><path pid="1" d="M84 222h52a6 6 0 006-6v-22a6 6 0 00-6-6H84a6 6 0 00-6 6v22a6 6 0 006 6zm-2-28a2 2 0 012-2h52a2 2 0 012 2v22a2 2 0 01-2 2H84a2 2 0 01-2-2zM84 172h52a6 6 0 006-6v-56a32 32 0 00-64 0v56a6 6 0 006 6zm-2-62a28 28 0 0156 0v56a2 2 0 01-2 2H84a2 2 0 01-2-2z"/>'
  }
})
